















































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
class BlankRow {
    voucherType: string = "";
    fromDate: string = "";
    toDate: string = "";
    voucherPages: string = "";
    accNum: string = "";
    remark: string = "";
}

@Component({
    ...mapGetters(["accountBook"]),
})
export default class CoverPrint extends Vue {
    @Prop({ type: String })
    period!: string;
    @Prop({ type: String })
    starPeriod!: string;
    @Prop({ type: String })
    startNo!: string;
    @Prop({ type: String })
    endNo!: string;
    @Prop({ type: Number })
    pages!: number;
    @Prop({ type: [String, Number] })
    totalAccessoryNo!: string | number;

    @Prop()
    taxPreparer!: string;
    @Prop()
    bindPeople!: string;

    ceNo: number = 1;
    ceAll: number = 1;

    // 获取焦点
    selectInner(e: any) {
        this.$nextTick(() => {
            e.target.select();
        });
    }

    get fromYear() {
        return this.starPeriod.substring(0, 4);
    }
    get fromMonth() {
        return this.starPeriod.substring(4);
    }
    fromDay: number = 1;
    toYear: string = this.period.substring(0, 4);
    toMonth: string = this.period.substring(4);
    toDay: number = 0;
    voucherType: string = "记账凭证";
    accNum: string = "";
    remark: string = "";

    blankRows: BlankRow[] = [new BlankRow(), new BlankRow(), new BlankRow()];
    totalPages: string = "";
    totalAcc: string = "";
    totalRemark: string = "";

    quanZong: string = "";
    muLu: string = "";
    anJuan: string = "";
    baoGuan: string = "";
    zhuGuan: string = "";
    baoShui: string = this.taxPreparer;
    zhuangDing: string = this.bindPeople;

    mounted() {
        this.toDay = new Date(+this.toYear, +this.toMonth, 0).getDate();
        this.showTop = ((this.$store.state.voucherPrint.top / 72) * 2.54).toFixed(2);
        this.showLeft = ((this.$store.state.voucherPrint.left / 72) * 2.54).toFixed(2);
        this.showRight = ((this.$store.state.voucherPrint.right / 72) * 2.54).toFixed(2);
    }
    @Watch("period")
    periodChange(val: any) {
        this.toYear = val.substring(0, 4);
        this.toMonth = val.substring(4);
        this.toDay = new Date(+this.toYear, +this.toMonth, 0).getDate();
    }
    @Prop({ type: Number })
    margin!: number;

    @Prop({ type: Number })
    padding!: number;

    @Prop({ type: Number })
    percent!: number;

    @Prop({ type: Boolean })
    horizontal!: boolean;


    startY = 0;
    endY = 0;
    startX = 0;
    endX = 0;
    startDrag(e: any) {
        this.startY = e.y;
    }

    startDragLeft(e: any) {
        this.startX = e.x;
    }

    paddingLr = this.$store.state.voucherPrint.left;
    get cmHeight(): string {
        return ((this.$store.state.voucherPrint.top / 72) * 2.54).toFixed(2);
    }
    get cmLeft(): string {
        return ((this.$store.state.voucherPrint.left / 72) * 2.54).toFixed(2);
    }
    get cmRight(): string {
        return ((this.$store.state.voucherPrint.right / 72) * 2.54).toFixed(2);
    }
    @Watch("cmHeight")
    marginChanged(val: string) {
        this.showTop = val;
    }
    @Watch("cmLeft")
    leftChanged(val: string) {
        this.showLeft = val;
    }
    @Watch("cmRight")
    rightChanged(val: string) {
        this.showRight = val;
    }
    showTop = ((45 / 72) * 2.54).toFixed(2);
    showLeft = ((30 / 72) * 2.54).toFixed(2);
    showRight = ((30 / 72) * 2.54).toFixed(2);

    voucherPrint = {
        top: this.$store.state.voucherPrint.top,
        left: this.$store.state.voucherPrint.left,
        right: this.$store.state.voucherPrint.right,
    };
    saveChange() {
        Vue.axios
            .post(`accounts/printer/set/save`, {
                voucherPrint: JSON.stringify(this.voucherPrint),
                accounterId: this.$store.state.account.id,
            })
            .then((res) => { });
    }
    changeTop() {
        let top = +this.showTop;
        if (+this.showTop < 0) {
            this.showTop = "0";
            top = (+0 / 2.54) * 72;
            this.voucherPrint.top = top;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        } else {
            top = (+top / 2.54) * 72;
            if (top > 100) {
                top = 100;
                this.showTop = (
                    (+this.$store.state.voucherPrint.top / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.top = top;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        }
    }
    changeLeft() {
        let Left = +this.showLeft;
        if (+this.showLeft < 0) {
            this.showLeft = "0";
            Left = 0;
            this.voucherPrint.left = Left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
            this.$forceUpdate();
        } else {
            Left = (+Left / 2.54) * 72;
            if (Left > 100) {
                Left = 100;
                this.showLeft = (
                    (+this.$store.state.voucherPrint.left / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.left = Left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
            this.$forceUpdate();
        }
    }
    changeRight() {
        let Right = +this.showRight;
        if (+this.showRight < 0) {
            this.showRight = "0";
            Right = 0;
            this.voucherPrint.right = Right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        } else {
            Right = (+Right / 2.54) * 72;
            if (Right > 100) {
                Right = 100;
                this.showRight = (
                    (+this.$store.state.voucherPrint.right / 72) *
                    2.54
                ).toFixed(2);
            }
            this.voucherPrint.right = Right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.saveChange();
        }
    }
    endDrag(e: any) {
        this.endY = e.y;
        let top = this.$store.state.voucherPrint.top;
        let distance = this.endY - this.startY;
        if (distance > 100) {
            top = 100;
        } else {
            top += distance;
        }

        if (top < 0) {
            top = 0;
        }
        this.voucherPrint.top = top;
        this.$store.dispatch("voucherPrintchange", this.voucherPrint);
        localStorage.setItem("voucherPrint", JSON.stringify(this.voucherPrint));
        this.showTop = (
            (this.$store.state.voucherPrint.top / 72) *
            2.54
        ).toFixed(2);
        this.saveChange();
    }

    endDragLeft(e: any, num: number) {
        let left = this.$store.state.voucherPrint.left;
        let right = this.$store.state.voucherPrint.right;
        this.endX = e.x;
        let distance = this.endX - this.startX;
        if (num === 0) {
            if (distance > 100) {
                left = 100;
            } else {
                left += distance;
            }
            if (left < 0) {
                left = 0;
            }
            this.voucherPrint.left = left;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.showLeft = (
                (this.$store.state.voucherPrint.left / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        } else {
            if (distance < -100) {
                right = 100;
            } else {
                right -= distance;
            }
            if (right > 100) {
                right = 100;
            }
            if (right < 0) {
                right = 0;
            }
            this.voucherPrint.right = right;
            this.$store.dispatch("voucherPrintchange", this.voucherPrint);
            localStorage.setItem(
                "voucherPrint",
                JSON.stringify(this.voucherPrint)
            );
            this.showRight = (
                (this.$store.state.voucherPrint.right / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        }
    }

    changeSet(attr: string, value: string) {
        Vue.axios.post(`accounts/printer/set/save`, {
            [attr]: value,
            accounterId: this.$store.state.account.id,
        });
    }
}
